import { cn } from "@/lib/utils";
import { Crown } from "lucide-react";

/**
 * Minimal "PRO" pill — appears next to Embaixador (premium) usernames
 * everywhere on the platform EXCEPT inside Mini Site templates
 * (those keep the original VerifiedBadge for context).
 */
export function ProBadge({
  size = "sm",
  className,
  "aria-label": ariaLabel = "PRO",
}: {
  size?: "xs" | "sm" | "md";
  className?: string;
  "aria-label"?: string;
}) {
  const sizing =
    size === "xs"
      ? "text-[10px] px-1.5 py-[2px] gap-0.5"
      : size === "md"
        ? "text-[13px] px-2.5 py-[4px] gap-1"
        : "text-[11px] px-2 py-[3px] gap-0.5";

  const iconSize = size === "md" ? 14 : size === "xs" ? 10 : 12;

  return (
    <span
      role="img"
      aria-label={ariaLabel}
      className={cn(
        "inline-flex items-center rounded-[4px] bg-[#9231FF] font-bold leading-none text-white align-middle tracking-normal",
        sizing,
        className,
      )}
    >
      <Crown size={iconSize} fill="currentColor" />
      Pro
    </span>
  );
}

export default ProBadge;
